import React, { useState, useEffect } from "react";
import styled from "styled-components";

const ImageContainer = styled.div`
  border-radius: 1rem;
  padding: 2px 2px;
  background: #95a5a6;
  display: flex;
  flex-direction: column;
  box-shadow: 1px 1px 12px #00000024;

  img {
    border-radius: 1rem;
  }
`;

const Container = styled.div`
  margin-top: 4rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    padding-bottom: 20vh;
  }
`;
const Heading = styled.h1`
  color: #393939;
  font-family: Poppins;
  width: 100%;
  font-weight: 600;
  font-size: 20px;
`;
const DetailsContainer = styled.div`
  width: 100%;
  padding-left: 3rem;
  @media (max-width: 768px) {
    padding-left: 0rem;
  }
`;

const TratisContainer = styled.div`
  min-height: 2vh;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;
const Gdiv = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 768px) {
    flex-direction: column !important;
  }
`;
const Trait = styled.div`
  border: 1px solid #00000024;
  border-radius: 2rem;
  margin-right: 1rem;
  display: flex;
  padding: 1rem;
  flex-direction: column;
  margin-left: 0.2rem;
  margin-top: 1rem;
  box-shadow: 0px 1px 6px #00000024;

  min-width: 10rem;
  @media (max-width: 768px) {
    margin-left: 0rem;
  }
`;
const Label = styled.label`
  color: #393939;
  font-size: 1.1rem;
  font-family: Poppins;
  padding: 0.5rem;
`;
const Span = styled.span`
  color: #3772ff;
  font-weight: 700;
  font-weight: 21px;
`;
const NftDataContainer = ({ nftData }) => {
  const [average, setAverage] = useState();
  useEffect(() => {
    if (nftData && nftData.traits.length > 0) {
      let total = 0;
      for (let i = 0; i < nftData.traits.length; i++) {
        total = total + nftData.traits[i].percentage;
      }
      let average = total / nftData.traits.length;
      setAverage(average);
    }
  }, []);

  return (
    <Container>
      <div>
        <ImageContainer>
          <img
            src={nftData.image_url}
            height="400"
            width="300"
            alt={"Gangster"}
          />
        </ImageContainer>
      </div>

      <DetailsContainer>
        <Gdiv>
          <Heading>Name: {nftData.name}</Heading>
          <Heading>Type: {nftData.type}</Heading>
          <Heading>class: {nftData.class}</Heading>
        </Gdiv>
        <Gdiv>
          <Heading>
            Total Score:{" "}
            <span style={{ color: "#e67e22" }}>
              {nftData.v2_total_score.toFixed(3)}
            </span>
          </Heading>
          {/* <Heading>Possible Score: {nftData.total_possible_score}</Heading> */}
          <Heading>
            % Rank:{" "}
            <span style={{ color: "#e67e22" }}>
              {nftData.v2_percentage_rank}
            </span>
          </Heading>
          <Heading>
            Score Rank:{" "}
            <span style={{ color: "#e67e22" }}>{nftData.v2_score_rank}</span>
          </Heading>
        </Gdiv>
        <Gdiv>
          <Heading>
            Total Possible Score:{" "}
            <span style={{ color: "#e67e22" }}>
              {nftData.v2_total_possible_score}
            </span>
          </Heading>
          <Heading>
            Total Traits:{" "}
            <span style={{ color: "#e67e22" }}>{nftData.traits.length}</span>
          </Heading>
        </Gdiv>
        {/* <div>
          {average && (
            <Heading style={{ color: "#ffffff" }}>
              Average Rarity :{" "}
              <span style={{ color: "#f1c40f" }}>
                {" "}
                &nbsp;{average.toFixed(2)} %
              </span>
              &nbsp;
              <span style={{ fontSize: "15px", color: "#bdc3c7" }}>
                ( NOTE: This is not Rarity Scrore, Its average Rarity % for
                every traits )
              </span>
            </Heading>
          )}
        </div> */}

        <TratisContainer>
          {nftData.traits.map((trait) => {
            return (
              <Trait>
                <Label>Attribute : {trait.key}</Label>
                <Label>Value : {trait.value}</Label>
                <Label>
                  Rarity : <Span>{trait.percentage.toFixed(2)}%</Span> have this
                  trait
                </Label>
                <Label>
                  Score :{" "}
                  <Span style={{ color: "#27ae60" }}>
                    {trait.v2_score.toFixed(2)}
                  </Span>
                </Label>
                <Label>
                  Count : <Span>{trait.count.toFixed(0)}</Span>
                </Label>
                <Label>
                  Weight(CR) : <Span>{trait.weight * 100}%</Span>
                </Label>
              </Trait>
            );
          })}
        </TratisContainer>
      </DetailsContainer>
    </Container>
  );
};
export default NftDataContainer;
